import Artwork from "@/pages/artwork";
import HomeArtists from "@/pages/home/artists";
import HomeArtlists from "@/pages/home/artlists";
import HomeArtworks from "@/pages/home/artworks";
import HomeDiscover from "@/pages/home/discover";
import HomeGalleries from "@/pages/home/galleries";
import SuarteWorld from "@/pages/home/suarteworld";
import CollectionPage from "@/shared-components/home/collection-page";

const HomeRoutes = [
  { path: "/", element: <HomeDiscover/> },
  { path: "/login", element: <HomeDiscover showAuthPopup={true} authPopUpPage={'login'} /> },
  { path: "/sign-up", element: <HomeDiscover showAuthPopup={true} authPopUpPage={'sign-up'} /> },
  { path: "/galleries", element: <HomeGalleries/> },
  { path: "/artists", element: <HomeArtists/> },
  { path: "/artworks", element: <HomeArtworks/> },
  { path: "/artlists", element: <HomeArtlists/> },
  
  { path: '/artwork/:slug', element: <Artwork /> },
  { path: "/suarteworld", element: <SuarteWorld /> },
  { path: '/suarteworld/artwork/:slug', element: <Artwork /> },

  /** SLIDER ROUTES */
  { path: "/collections/:collection_id", element: <CollectionPage /> },
  { path: "/limited-editions", element: <CollectionPage collectionEndpoint="/category/limited_editions" collName="Limited Editions" title="Limited Editions | Start and keep growing your collection" metadescription="Discover Suarte's LEs, where the art of desire meets affordability. Secure a piece of excellence with 250 carefully printed works per edition and showcase it in your profile."/> },
];

export default HomeRoutes;